import { PadNumberType } from "../enums/pad-number-type.enum";

export const padNumberPrefixDict: Record<PadNumberType, number> = {
    [PadNumberType.DefaultType]: 4,
    [PadNumberType.MetalsHardwareItem]: 4,
    [PadNumberType.PlasticsProduct]: 6,
    [PadNumberType.MetalsWorkOrder]: 4,
    [PadNumberType.PlasticsFixture]: 4,
    [PadNumberType.Procedure]: 3,
    [PadNumberType.ProcedureInstance]: 4,
    [PadNumberType.LaserProgram]: 4,
    [PadNumberType.PlasticsOrder]: 5,
    [PadNumberType.MetalsOrder]: 5,
    [PadNumberType.C3Order]: 5,
    [PadNumberType.MetalsLaserProgram]: 4,
}